const data = [
    { id: 1, name: "Sem uniforme" },
    { id: 2, name: "Faltou aula" },
    { id: 3, name: "Bullying" },
    { id: 4, name: "Problema disciplinar" },
    { id: 5, name: "Outros" },
]

export default [...data]